var exports = {
  "m2": "transferWarningFlash__nEIQZe",
  "Sq": "stickyObservableBox__hkOuz1",
  "MX": "HeaderContentWrapper__iMgvTd",
  "NH": "HeaderContentWrapper_stickyHeader__IYFppI",
  "gE": "HeaderContentWrapper_inlineAvatars__uNVYAK",
  "AN": "headerSpacer__q-zg6l",
};

module.exports = exports;
